
export default [
  {
    path: '/student-insurances',
    name: 'student-insurance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-insurance/index.vue'),
  }
]
